import PropTypes from 'prop-types'
import React, { Component } from 'react'
import getActivityClassName from 'helpers/dashboard/getActivityClassName'
import styles from './activity-progress.styl'

export default class ActivityProgress extends Component {
  static propTypes = {
    white: PropTypes.bool,
    completedPercentage: PropTypes.number,
    activitySection: PropTypes.string,
  }

  static defaultProps = {
    white: false
  }

  render() {
    const { activitySection, white, completedPercentage } = this.props

    const classNames = [
      styles.wrap,
      styles[getActivityClassName(activitySection)]
    ]

    white && classNames.push(styles.white)

    return (
      <div className={classNames.join(' ')}>
        <div className={styles.inner} style={{ right: `${100 - completedPercentage}%` }} />
      </div>
    )
  }
}
